import type { AppModule } from "../types";
import { s } from "./strings";

/** `/teams` with hash tabs (#members, #limited, #groups, #reminders); routes.md, team spec 1. */
export const teamModule: AppModule = {
  name: "team",
  routes: {
    shell: [
      {
        path: "/teams",
        handle: { title: "Team" },
        lazy: () => import("./pages/TeamPage").then((m) => ({ Component: m.TeamPage })),
      },
    ],
  },
  sidebar: [{ id: "TEAM", label: s.title, path: "/teams", icon: "team", alt: "View team" }],
};
